import React from "react";
import { TopTrendingListViewMoreLoaderTemplate } from "themes/administration/analytics/components";

function TopTrendingListViewMoreLoader(props) {
    return <TopTrendingListViewMoreLoaderTemplate {...props} />;
}

export default TopTrendingListViewMoreLoader;
